// extracted by mini-css-extract-plugin
export default {"lower_content":"style_lower_content__1rOqn","timeline":"style_timeline__M4pL8","card":"style_card__Ae83b","main_post":"style_main_post__pPA-Z","header":"style_header__njvT8"};